import { Component, OnDestroy } from '@angular/core';
import { NavController, NavParams, LoadingController, Platform, ToastController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Success } from '../success/success';
import { Subject } from 'rxjs';

@Component({
  selector: 'page-credit-payment',
  templateUrl: 'credit-payment.html',
})
export class CreditPaymentPage implements OnDestroy {

  private _onDestroy = new Subject();

  order: any;
  creditCardForm: FormGroup;
  masks: any;
  messages: any;
  placeholders = {
    number: '•••• •••• •••• ••••',
    name: 'Nome Completo',
    expiry: '••/••',
    cvc: '•••'
  };

  message:any;
  tot:any;
  valuta:any;
  takeAway:any;
  deliveryCost:any;
  deliveryDiscount:any;
  menuData: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public provider: provider,
    public storage: Storage,
    public translateService: TranslateService,
    public platform: Platform,
    private formBuilder: FormBuilder,
    public toastCtrl: ToastController,
  ) {
    this.order = navParams.get('order');
    this.message = navParams.get('message');
    this.tot = navParams.get('tot');
    this.valuta = navParams.get('valuta');
    this.takeAway = navParams.get('takeaway');
    this.deliveryCost = navParams.get('deliveryCost');
    this.deliveryDiscount = navParams.get('deliveryDiscount');

    this.creditCardForm = this.formBuilder.group({
      'name': ['', Validators.required],
      'number': ['', Validators.required],
      'cvv': ['', Validators.required],
      'expDate': ['', Validators.required],
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CreditPaymentPage');
  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  makePayment() {
    const formData = this.creditCardForm.value;
    const creditCardExpiryDate = formData.expDate.split('/')
    const paymentToken = this.order.sellaPayment.paymentToken;
    const shopLogin = this.order.shoplogin;

    const data = {
      shopLogin: shopLogin,
      buyer:{
        email:'',
        name: formData.name
      },
      paymentTypeDetails: {
        creditcard: {
            number: parseInt(formData.number.replace(/\s+/g, '')),
            expMonth: creditCardExpiryDate[0].trim(),
            expYear: creditCardExpiryDate[1].trim(),
            CVV: formData.cvv,
            DCC:null
        }
      }
    }

    const loading = this.loadingCtrl.create({
      content: '<ion-spinner name="circles"></ion-spinner>'
    });

    loading.present().then(() => {
      this.provider.makeCreditCardPayment(data, paymentToken).subscribe(
        result => {
          const bodyResult = JSON.parse((<any>result)._body);

          loading.dismiss().then(()=> {
            if (bodyResult.payload.transactionResult === 'OK') {
              //pagato
              this.navCtrl.push(Success, {
                message: this.message,
                tot: this.tot,
                valuta: this.valuta,
                takeaway: this.takeAway,
                deliveryCost: this.deliveryCost,
                deliveryDiscount: this.deliveryDiscount
              });

              let toast = this.toastCtrl.create({
                message: 'Pagamento Effettuato',
                duration: 3000,
                position: 'middle'
              });
              toast.present();
            } else {
              if (bodyResult.payload.transactionErrorCode === '8006') {
                  window.open(bodyResult.payload.userRedirect.href, '_system');
                  this.navCtrl.pop();
              } else {
                  //rifiutato
                  this.navCtrl.pop();

                  let toast = this.toastCtrl.create({
                    message: 'Pagamento Rifiutato',
                    duration: 3000,
                    position: 'middle'
                  });
                  toast.present();
              }
            }
          });
        },
        error => {
          loading.dismiss().then(() => {
            this.navCtrl.pop();
            let toast = this.toastCtrl.create({
              message: 'Pagamento Rifiutato',
              duration: 3000,
              position: 'middle'
            });
            toast.present();
          })
        }
      )
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/credit-payment/credit-payment.ts